import {
    localCalendarDateOnly,
    localCalendarDateOnlyDaysAgo,
} from '../../dwt-payloads/utils/local-calendar-date-only.util';
import {
    DWT_DEFRA_SUBMISSIONS_DEFAULT_LOOKBACK_DAYS,
    DWT_DEFRA_SUBMISSIONS_END_DATE_ELEMENT_ID,
    DWT_DEFRA_SUBMISSIONS_START_DATE_ELEMENT_ID,
} from '../dwt-defra-submissions.constants';

/**
 * Inclusive last-N-days window for the DEFRA start/end date inputs (HTML `YYYY-MM-DD`).
 * The task pane date control displays that value in the user's locale (dd/mm/yyyy on UK Windows).
 */
export function getDwtDefraSubmissionsDefaultDateRange(now: Date = new Date()): {
    startDate: string;
    endDate: string;
} {
    return {
        startDate: localCalendarDateOnlyDaysAgo(
            DWT_DEFRA_SUBMISSIONS_DEFAULT_LOOKBACK_DAYS - 1,
            now
        ),
        endDate: localCalendarDateOnly(now),
    };
}

/** Prefills start/end date inputs when the DEFRA submissions target is rendered. */
export function getDwtDefraSubmissionsDateFieldRendererDefaults(
    now: Date = new Date()
): Readonly<Record<string, string>> {
    const range = getDwtDefraSubmissionsDefaultDateRange(now);
    return {
        [DWT_DEFRA_SUBMISSIONS_START_DATE_ELEMENT_ID]: range.startDate,
        [DWT_DEFRA_SUBMISSIONS_END_DATE_ELEMENT_ID]: range.endDate,
    };
}
